import axios from "axios";
import { getAccessToken } from "./getToken";

const microsoftGraphInstance = axios.create({
  baseURL: "https://graph.microsoft.com/v1.0/",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

microsoftGraphInstance.interceptors.request.use(
  async (config) => {
    const token = await getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default microsoftGraphInstance;
